import { Button, Grid, Typography } from '@mui/material'
import { CreditRatingOption, PersonalLoanCalculatorGridSizes } from '@src/types/Constants'
import { useTranslation } from 'react-i18next'

interface CreditRatingSelectorProps {
  options: CreditRatingOption[]
  creditRatingInterestRate: number
  onRatingChange: (rate: number) => void
  disabled?: boolean
}

export const CreditRatingSelector = ({
  options,
  creditRatingInterestRate,
  onRatingChange,
  disabled = false,
}: CreditRatingSelectorProps) => {
  const { t } = useTranslation()

  const renderCreditRatingOption = (option: CreditRatingOption, index: number) => (
    <Grid key={index} size={PersonalLoanCalculatorGridSizes.CREDIT_RATING}>
      <Button
        variant="outlined"
        color="inherit"
        fullWidth
        disabled={disabled}
        sx={{
          whiteSpace: 'nowrap',
          textAlign: 'center',
          color: creditRatingInterestRate === option.interestRate ? 'primary.main' : 'text.primary',
          fontWeight: creditRatingInterestRate === option.interestRate ? 'bold' : 'normal',
        }}
        onClick={() => onRatingChange(option.interestRate)}
      >
        <div>
          <Typography variant="body1" component="div">
            {t(`calculator.creditRatingOptions.${option.label}`)}
          </Typography>
          <Typography variant="body1" component="div">
            {`${option.range}`}
          </Typography>
        </div>
      </Button>
    </Grid>
  )

  return (
    <>
      <Typography variant="h6" component="h6" gutterBottom sx={{ mt: 3 }}>
        {t('calculator.creditRating')}
      </Typography>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {options.map(renderCreditRatingOption)}
      </Grid>
    </>
  )
}
